import * as React from 'react';
import styled from 'styled-components';
import YouTube, { Options } from 'react-youtube';

import { ModuleSocialEmbed } from '@packages/common';

const videoProps: Options = {
  height: '716',
  width: '1280',
  playerVars: {
    modestbranding: 1,
    rel: 0,
    showinfo: 0,
    disablekb: 1,
    color: 'white',
  },
};

export const Container = styled.div`
  position: relative;
  padding-bottom: ${(Number(videoProps.height) / Number(videoProps.width)) * 100}%;
  height: 0;
  overflow: hidden;

  & iframe,
  & object,
  & embed {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

export type YouTubeEmbedProps = ModuleSocialEmbed;

export const YouTubeEmbed: React.FC<YouTubeEmbedProps> = ({ embedCode }) => (
  <Container data-testid="embed-container">
    <YouTube videoId={embedCode} opts={videoProps} />
  </Container>
);
